// extracted by mini-css-extract-plugin
export default {"select-org-role":"gMzfGJ1XK2BKp_7nSsD_","select-org-role-read-only":"SmYPm0v2AYGuUEMI8uy3"};